// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"courses_spinnerContainer__NcXrw","spinner":"courses_spinner__QE5tA","spin":"courses_spin__hU2uz"};